import React from 'react';
import { IconContainer } from './IconContainer';

const ArrowIcon = (props) => {
    return (
        <IconContainer ariaLabel="arrow" {...props}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.4766 9.16667L9.00665 4.69667L10.185 3.51834L16.6666 10L10.185 16.4817L9.00665 15.3033L13.4766 10.8333H3.33331V9.16667H13.4766Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { ArrowIcon };